var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 111,
    viewBox: "0 0 102 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6129_50169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3882 53.018C67.1412 54.2083 67.1412 56.7916 65.3882 57.9819L39.9135 75.2793C37.9216 76.6318 35.2282 75.205 35.2282 72.7974L35.2282 38.2025C35.2282 35.7949 37.9216 34.3681 39.9135 35.7206L65.3882 53.018Z",
    fill: "#F22B5D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2649 53.0053C70.0433 54.1931 70.0433 56.8069 68.2649 57.9947L38.4163 77.9311C36.4228 79.2626 33.75 77.8336 33.75 75.4364L33.75 35.5636C33.75 33.1664 36.4228 31.7374 38.4163 33.0689L68.2649 53.0053Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6129_50169",
    x: 0.228027,
    y: 0.197266,
    width: 101.475,
    height: 110.605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    result: "effect1_foregroundBlur_6129_50169"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.5a4621ac07a4d23cbae492ce07779aee.svg";
export { ForwardRef as ReactComponent };